import React from 'react';
import {Box} from '@chakra-ui/react';
import {SectionContainer, SectionTitle} from './helpers';
import {useAgentBuilderStore} from '../AgentBuilder.state';
import {AutoRefreshOptions} from '../AutoRefreshOptions';

export const AutoRefreshSection = () => {
  const {
    autoEnrichNewAccounts,
    setAutoEnrichNewAccounts,
    autoEnrichSchedule,
    setAutoEnrichSchedule,
  } = useAgentBuilderStore();
  return (
    <SectionContainer>
      <SectionTitle>Auto-Refresh</SectionTitle>
      <Box color="kgray.300">
        Disable or enable automatic runs of this enrichment.
      </Box>
      <AutoRefreshOptions
        autoEnrichNewAccounts={autoEnrichNewAccounts}
        setAutoEnrichNewAccounts={setAutoEnrichNewAccounts}
        autoEnrichSchedule={autoEnrichSchedule}
        setAutoEnrichSchedule={setAutoEnrichSchedule}
      />
    </SectionContainer>
  );
};
